<template>
  <div class="mian">
 
    <!-- 轮播图 -->
    <div>
      <van-swipe :show-indicators="true" :autoplay="3000" :loop="true">
        <van-swipe-item v-for="(item, index) in banner_img" :key="index">
          <img :src="$global.account_url + item" style="width: 100%" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- 门诊功能选择列表 -->
    <div class="list" v-show="menZhenVisbale">
      <a
        v-for="(item, index) in icons"
        :key="index"
        @click="go_item(item)"
      >
        <div>
          <img :src="$global.account_url+item.pic" />
        </div>
        <p>{{ item.name }}</p>
      </a>
    </div>
  </div>
</template>

<script>
import Nav from "../../components/nav.vue";

import Vue from "vue";
import { Swipe, SwipeItem } from "vant";
import { Dialog } from "vant";
Vue.use(Swipe);
Vue.use(SwipeItem);

export default {
  components: {
    Nav,
  },
  data() {
    return {
      zhuYuanVisbale: false,
      menZhenVisbale: true,
     //轮播图
      banner_img: [],
      openid: "",
      //incons
      icons: [],
      //医院信息
      hsopInfo: {},
      hospInfo_url: "",
      menZhenImgShow: {
        off: require("../../assets/homeImg/mz_off.png"),
        on: require("../../assets/homeImg/mz_on.png"),
      },  
      zhuYauanImgShow: {
        off: require("../../assets/homeImg/zy_off.png"),
        on: require("../../assets/homeImg/zy_on.png"),
      },

      lunbolist: [{ src: require("../../assets/homeImg/lunbotu01.png") }],
    };
  },
  created(){
    this.init()
  },
  methods: {
     go_item(item) {
      if (item.type == "2") {
        if (!this.hospInfo_url) {
          this.$toast.fail("该功能暂未开放");
        }
        window.location.href = this.hospInfo_url;
        // "https://mp.weixin.qq.com/s/WfdsKVEdjK4b2SobWR9YPg";
        return;
      }
      if (item.type == "3") {
         let openId = this.$local.get("openid");
        let url = `${item.hospInfo_url}$openId=${openId}`
        window.location.href = item.hospInfo_url;
        return;
      }
      if (item.url == "#") {
        this.$toast.fail("该功能暂未开放");
      }
      if (this.openid) {
        this.$router.push(item.url + "?openid=" + this.openid);
      } else {
        this.$router.push(item.url);
      }
    },
    async init() {
      //请求医院信息
      // 医院的名字、地址、banner图片、图标、功能
      try {
        this.$showLoad();
        this.isLoad = true;
        let url = "/index/getBasicIndex";
        await this.$axios_request.request_data(
          "nodeserver",
          url,
          "post",
          null,
          (data) => {
            console.log(data);
            //轮播图
            this.banner_img = data.data.banner;
            // icons
            this.icons = data.data.modules.content;
            //第三方地址
            this.hospInfo_url = data.data.modules.hosp_info_url;
            //医院名
            this.hsopInfo = data.data.basic_info;
            // if(this.hsopInfo){
            //   this.$local.set("Hspname", this.hsopInfo.hospital_name);
            // }
            // console.log(this.hsopInfo)
            // console.log(this.hsopInfo.hospital_address);
            this.$hideLoad();
            this.getalret();
            //           Dialog.alert({
            //   message: '该公众号目前数据均为测试数据，你所录入的数据也将录入测试数据',
            // }).then(() => {
            //   // on close
            // });
            this.isLoad = false;
          }
        );
      } catch (error) {
        console.log(error);
        this.isLoad = false;
        this.$hideLoad();
        this.$toast.fail("网络连接失败");
      }
    },

    async getalret() {
      //请求医院信息
      // 医院的名字、地址、banner图片、图标、功能
      try {
        this.$showLoad();
        let url = "/hospitalconf/index/getHopitalNotice";
        let data = null;
        await this.$axios_request.request_data(
          "nodeserver",
          url,
          "post",
          null,
          (data) => {
            //  console.log(data.data)
            if (data.data.content) {
              Dialog.alert({
                message: data.data.content,
              }).then(() => {});
            }
            this.$hideLoad();
          }
        );
      } catch (error) {
        this.isLoad = false;
        this.$hideLoad();
        this.$toast.fail("网络连接失败");
      }
    },
    goItem(item) {
      if (item.text == "预约挂号") {
        this.$router.push({
          name: "department",
          querry: {},
        });
      }
    },

    show(data) {
      // console.log(this.Navigation);
      /* 将所有功能列表设置为不可见 */
      this.zhuYuanVisbale = false;
      this.menZhenVisbale = false;
      /* 将选中的功能列表设置为可见 */
      switch (data) {
        case "门诊":
          this.menZhenVisbale = true;

          break;
        case "住院":
        default:
          this.zhuYuanVisbale = true;
          break;
      }
      /* 改变底部导航栏的被选中状态 */
      for (var index = 0; index < this.Navigation.length; index++) {
        if (this.Navigation[index].text == data) {
          this.Navigation[index].src = this.Navigation[index].imgOn;
          this.Navigation[index].color = this.Navigation[index].textOn;
        } else {
          this.Navigation[index].src = this.Navigation[index].imgOff;
          this.Navigation[index].color = this.Navigation[index].textOff;
        }
      }
    },
  },
};
</script>

<style>
.topflag {
  display: flex;
  left: 0px;
  width: 100%;
  position: fixed;
  bottom: 0px;
  background-color: #f7f7fa;
  text-align: center;
  z-index: 1993;
}
.list {
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 60px;
}
.list > a {
  width: 50%;
  text-align: center;
  padding: 20px 30px;
  border-right: 0.1px solid #d9d9d9;
  border-bottom: 0.1px solid #d9d9d9;
  background-color: white;
}
.list > a > div > img {
  width: 80px;
  height: 80px;
}
.list > a > p,
.topflag > div > p {
  font-size: 20px;
}
.topflag > div > img {
  width: 50px;
  height: 40px;
}
.list > a > p {
  color: #aaaaaa;
}
.mian {
  width: 100vw;
  margin-bottom: 15px;
}
body {
  background-color: #f3f3f3;
}
.topflag {
  padding-top: 5px;
  border-top: 0.1px solid #d9d9d9;
}
</style>
